// Controllers included by the sidebar templates.
// @todo Should probably be more dynamic.
(function () {
	angular
		.module('trackeye')
		.controller('SidebarController', SidebarController);

	SidebarController.$inject = ['$scope', '$state', 'DeviceService', 'AuthService', 'AccountService'];

	function SidebarController($scope, $state, DeviceService, AuthService, AccountService) {
		var vm = this;

		/**
		 * @type {Device}
		 */
		vm.selectedDevice = undefined;
		vm.hasPrepaids = undefined;
		vm.hasRapidPoliceDevices = undefined;
		vm.selectedDeviceMessage = undefined;
		vm.activeSubPage = $state.params.page;
		vm.account = AccountService.get();

		$scope.$on('DeviceService.initialized', function () {
			vm.hasPrepaids = DeviceService.hasPrepaidDevices();
			vm.hasRapidPoliceDevices = DeviceService.hasRapidPoliceDevices();
			vm.selectedDeviceMessage = DeviceService.getSelectedMessage();
		});

		$scope.$on('DeviceService.selected', function (event, device) {
			vm.selectedDevice = device;
		});

		vm.stateGo = function(state) {
			$state.go('dashboard.main.pages', {page: state});
			vm.activeSubPage = state;
		};

		vm.isStateActive = function (state) {
			return state === vm.activeSubPage;
		};

		vm.logout = function () {
			AuthService.logout();
			AuthService.flushPersistentToken();
			$state.go('main');
		};

	}
})();